<template>
  <svg
    width="779"
    height="365"
    viewBox="0 0 779 365"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <text
      x="375"
      y="300"
      text-anchor="middle"
      font-family="Manrope, sans-serif"
      font-size="300"
      font-weight="700"
      fill="#C4C4C4"
    >
      500
    </text>
    <path
      d="M676 139C707.48 139 733 113.48 733 81.9995C733 50.5193 707.48 24.9995 676 24.9995C644.52 24.9995 619 50.5193 619 81.9995C619 113.48 644.52 139 676 139Z"
      fill="#FF6347"
    />
    <path
      d="M690.494 64.5339C714.649 81.9362 733.404 101.973 744.207 120.28C749.609 129.435 753.011 138.136 754.12 145.845C755.228 153.55 754.043 160.231 750.316 165.404C746.589 170.578 740.627 173.817 732.967 175.205C725.304 176.594 715.973 176.123 705.579 173.897C684.793 169.446 659.849 158.001 635.694 140.599C611.539 123.197 592.785 103.16 581.981 84.8523C576.579 75.6977 573.178 66.9964 572.069 59.2879C570.96 51.5827 572.145 44.9017 575.872 39.7284C579.6 34.555 585.562 31.3156 593.221 29.9273C600.884 28.5385 610.215 29.01 620.609 31.2356C641.396 35.6864 666.339 47.1316 690.494 64.5339Z"
      fill="#E35F2F"
      stroke="#F4F6F5"
    />
    <path
      d="M676.859 82.6241C708.094 105.127 727.004 132.268 719.096 143.246C711.188 154.223 679.455 144.879 648.22 122.376C616.984 99.8728 598.074 72.7316 605.982 61.7544C613.891 50.7772 645.623 60.1209 676.859 82.6241Z"
      fill="white"
    />
    <path
      d="M696.5 34.9993C694 32.8326 686.6 28.7993 677 29.9993"
      stroke="white"
      stroke-width="5"
      stroke-linecap="round"
    />
    <path
      d="M668.58 31.1509C666.5 31.1509 665.5 31.4993 664 31.9993"
      stroke="white"
      stroke-width="5"
      stroke-linecap="round"
    />
    <path
      d="M684.5 356.998L720 140.999C725 133.499 710.5 113.499 706 108.498C700.673 102.578 692.945 94.5267 681 85.4979C673.592 79.898 664.681 73.6381 653 67.9983C649.111 66.1206 643.723 63.4741 642.5 62.9986C624.5 55.9981 614 55.4977 607.5 59.9984L0 356.998H684.5Z"
      fill="url(#paint0_linear_server_error)"
      fill-opacity="0.54"
    />
    <defs>
      <linearGradient
        id="paint0_linear_server_error"
        x1="647"
        y1="67.9991"
        x2="592.5"
        y2="342.999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D1FBEC" />
        <stop offset="1" stop-color="#D1FBEC" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>
